import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Global Members/Crypto/Crypto.md";
import * as React from 'react';
export default {
  Content,
  React
};